import actions from './actions'
import { MailExportState, SetExportingPayload } from './types'

const initialState: MailExportState = {
  isExporting: false,
}

interface MailExportAction {
  type: string
  payload?: SetExportingPayload
}

export default function mailExportReducer(
  state: MailExportState = initialState,
  action: MailExportAction,
): MailExportState {
  switch (action.type) {
    case actions.SET_EXPORTING:
      return { ...state, isExporting: action.payload?.isExporting ?? false }
    default:
      return state
  }
}
